export default class Footer {
  createFooter() {
    this.footer = document.createElement('footer');
    this.footer.classList.add('footer');
    this.footer.innerHTML = ` 
    <div class="footer-wrapper">
    <div class="footer_school-logo">
    <p><a href="https://rs.school/js/">RS School 2020</a></p>
    </div>
    <div class="footer_git-logo"><p><a href="https://github.com/ahureikinandrei">Andrei Ahureikin</a></p></div></div>`;
    document.body.appendChild(this.footer);
  }

  addLogo() {
    this.footerLogo = document.querySelector('.footer_git-logo');
    this.footerLogo.style.backgroundImage = "url('../../assets/icongithub.svg')";
  }

  init() {
    this.createFooter();
    this.addLogo();
  }
}
